// GAVION commissions: Paramètres → Forfaits and Plans de commission.
export const commissionsSettingsFr = {
  saved: "Enregistré",
  edit: "Modifier",
  edit_named: "Modifier %{name}",
  save: "Enregistrer",
  cancel: "Annuler",
  inactive: "inactif",
  both_lines: "Les deux gammes",
  fields: {
    code: "Code",
    name: "Nom",
    line: "Gamme",
    tier: "Niveau",
    monthly_price: "Prix par mois ($)",
    unit_price: "Prix unitaire ($)",
    billing: "Facturation",
    included: "Inclus (minutes, utilisateurs, agents, soumissions)",
    position: "Ordre",
    active: "Actif",
  },
  errors: {
    required: "Champ requis.",
    code: "Lettres minuscules, chiffres et _ seulement (60 au plus).",
    amount: "Entrez un montant entre 0 et 100 000.",
    int: "Entrez un nombre entier.",
    duplicate_code: "Ce code existe déjà.",
    pct: "Entrez un pourcentage entre 0 et 100.",
    date: "Entrez une date.",
    order: "La fin doit suivre le début.",
    overlap: "Cette personne a déjà un plan pour cette période.",
    months: "Entrez un nombre de mois entre 0 et 120.",
    days: "Entrez un nombre de jours entre 0 et 3 650.",
    sources: "Choisissez au moins une source.",
    version_date:
      "La nouvelle version commence ce mois-ci ou plus tard, après le début du plan actuel.",
    long: "Texte trop long.",
  },
  packages: {
    title: "Forfaits",
    intro:
      "Le catalogue des forfaits et des options. Un abonnement garde le prix du jour où il est saisi : changer un prix ici ne change aucun mois déjà facturé.",
  },
  package: { title: "Forfaits", add: "Ajouter un forfait" },
  addon: { title: "Options", add: "Ajouter une option" },
  discount: {
    title: "Rabais annuel",
    label: "Rabais pour un paiement annuel (%)",
    hint: "Sert à proposer le montant annuel d'un nouvel abonnement.",
  },
  plans: {
    title: "Plans de commission",
    intro:
      "Un plan par personne et par période. Sans plan, aucune commission ni prime.",
    empty: "Aucun plan de commission.",
    add: "Ajouter un plan",
    edit_title: "Modifier le plan",
    save: "Enregistrer le plan",
    new_version: "Nouvelle version",
    new_version_named: "Nouvelle version du plan de %{name} du %{from}",
    new_version_title: "Nouvelle version du plan",
    new_version_save: "Créer la nouvelle version",
    new_version_hint:
      "Ce plan est en vigueur : ses taux passés ne changent jamais. Le plan actuel se termine la veille de la date choisie et une nouvelle ligne commence ce jour-là.",
    delete_locked: "Déjà versé : non supprimable",
    delete: "Supprimer",
    confirm_delete: "Supprimer ce plan de commission ?",
    edit_named: "Modifier le plan de %{name} du %{from}",
    delete_named: "Supprimer le plan de %{name} du %{from}",
    from_to: "du %{from} au %{to}",
    from_open: "depuis le %{from}",
    summary:
      "%{rate_initial} % × %{months} mois, puis %{rate_after} % · part %{split} % · prime %{bonus}",
    grid: "tout %{full} % · rendez-vous seul %{appt} % · rendez-vous + démo %{appt_demo}",
    to_decide: "À décider",
    grid_title: "Qui touche quoi, selon qui fait chaque étape",
    vacation_pay_help:
      "0 = non calculé (compté à part par la paie, pour l'instant). Sinon 4 %, 6 % après 3 ans de service continu (LNT art. 74) : affichée sur chaque relevé pour la paie, jamais ajoutée au total.",
    employment_end_on: "fin d'emploi %{date}",
    fields: {
      sales_id: "Personne",
      effective_from: "En vigueur du",
      effective_to: "Jusqu'au (vide : sans fin)",
      rate_initial_pct: "Taux des premiers mois (%)",
      initial_months: "Nombre de mois au premier taux",
      rate_after_pct: "Taux ensuite (%)",
      full_share_pct: "Rendez-vous, démo et conclusion (%)",
      demo_by_other_split_pct: "Conclusion, démo par une autre personne (%)",
      appointment_bonus: "Rendez-vous seulement : prime ($)",
      appointment_share_pct:
        "Rendez-vous seulement : part de la commission (%)",
      appointment_demo_share_pct:
        "Rendez-vous et démo, conclusion par une autre personne (%, vide : À décider)",
      bonus_window_days: "Fenêtre de la prime (jours)",
      vacation_pay_pct: "Indemnité de vacances (%)",
      eligible_sources: "Sources admissibles",
      employment_end: "Fin d'emploi (vide : en poste)",
      note: "Note",
    },
  },
};
